import React from 'react'
import Header from '../../Home/Header';
import Footer from '../../Home/Footer';
import AboutUsVision from './AboutUsVision';
import AboutUsVision2 from './AboutUsVision2';
const VisionandMission = () => {
  return (
    <>
      <Header />
      <AboutUsVision />
      <AboutUsVision2 />
      <Footer />
    </>
  )
}

export default VisionandMission